module.exports = __webpack_public_path__ + "img/dashboard_white.e2016567.svg";